module.exports = __webpack_public_path__ + "img/9788993094725.fa2f3509.jpg";